// stores/seo.ts
import { defineStore } from "pinia";
import { consola } from "consola";
import { useSettingsStore } from "@stores/settings";
import { useRoute } from "vue-router";

interface SeoData {
  title: string;
  content: string;
}

interface SectionConfig {
  section: string;
  sourceId: string | null;
}

export const useSeoStore = defineStore("seo", () => {
  const route = useRoute();
  const seo: Ref<SeoData> = ref({
    title: "",
    content: ""
  });

  const settingsStore = useSettingsStore();
  const sectionMapping: Record<string, SectionConfig> = {
    "play-id": { section: "casino_games", sourceId: null },
    "casino-live": { section: "casino_categories", sourceId: "2" },
    "casino-slots": { section: "casino_categories", sourceId: "1" },
    "index": { section: "home_page", sourceId: null },
    "sports": { section: "sports", sourceId: null }
  };

  function getRouteConfig(): SectionConfig {
    const routePath = route.path;
    const routeName = route.name as string;
    const sourceId = Object.values(route.params)[0]?.toString() || null;

    if (routePath.match(/^\/casino\/[\w-]+$/)) {
      return { section: "casino_categories", sourceId };
    }

    if (routePath.match(/^\/providers\/[\w-]+$/)) {
      return { section: "casino_providers", sourceId };
    }

    const mappedSection = sectionMapping[routeName];
    if (mappedSection) {
      return {
        ...mappedSection,
        sourceId: mappedSection.section === "casino_games" ? sourceId : mappedSection.sourceId
      };
    }

    return { section: routeName, sourceId };
  }

  async function fetchPageSeo(): Promise<SeoData | undefined> {
    try {
      const { section, sourceId } = getRouteConfig();
      const query = `?section_name=${section}${sourceId ? "&source_id=" + sourceId : ""}`;
  
      const { data, status } = await useFetch(`/api/seo${query}`);

      if (status.value === '204' || !data.value) {

        seo.value = {
          title: "",
          content: ""
        };
        return seo.value;
      }
      
      seo.value = data.value as SeoData;
      return seo.value;
    } catch (error) {
      consola.error("[SEO Store] Error:", error);
 
      seo.value = {
        title: "",
        content: ""
      };
      return seo.value;
    }
  }

  return {
    seo,
    fetchPageSeo
  };
});